import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { adminApi } from '../services/api.jsx';
import { ChargementPleinEcran } from '../etats';

/* ═══════════════════════════════════════════════════════════════════════════
   PAGE D'ARRIVÉE

   Après une connexion, tout le monde était envoyé sur /dashboard. Or cette
   zone est réservée à l'équipe d'exploitation : un coach y arrivait pour n'y
   trouver qu'« Accès réservé à l'équipe ASSO-PRO » — un message d'échec en
   guise d'accueil, alors que son compte fonctionnait parfaitement.

   L'arrivée est donc décidée par le serveur : on ouvre la première zone qu'il
   déclare accessible. Ajouter un rôle ou déplacer un droit dans la table des
   zones suffit désormais à corriger l'accueil, sans toucher ici.
   ═══════════════════════════════════════════════════════════════════════════ */

export default function AccueilSelonRole({ repli = '/dashboard' }) {
  const [chemin, setChemin] = useState(null);

  useEffect(() => {
    let actif = true;
    adminApi.mesZones()
      .then((donnees) => {
        if (!actif) return;
        const zones = donnees?.zones || [];
        setChemin(zones[0]?.chemin || repli);
      })
      // En cas d'échec réseau on retombe sur la page par défaut : mieux vaut
      // une page qui refuse l'accès qu'un écran de chargement sans issue.
      .catch(() => actif && setChemin(repli));
    return () => { actif = false; };
  }, [repli]);

  // La forme de la page d'arrivée n'est pas connue avant la réponse : un
  // chargement plein écran, qui dit ce qu'on attend.
  if (!chemin) return <ChargementPleinEcran texte="Ouverture de votre espace…" />;
  return <Navigate to={chemin} replace />;
}
